import styled from "styled-components";

export const LabelStyled = styled.label`

`;
